import apiClientService from '@/services/api/ambassador/clientService';
import apiTypeService from '@/services/api/common/typeService';

export default {
  async getClient({ commit }, { clientId }) {
    const client = await apiClientService.getById(clientId);
    commit('setSelectedClient', client);
    commit('app/setFocusedObject', client, { root: true });
  },
  async getTypes({ commit }) {
    const types = await apiClientService.getTypes();
    commit('setTypes', types);
  },
  async getTypeCategories({ commit }) {
    const categories = await apiTypeService.getClientCategories();
    commit('setTypeCategories', categories);
  },
  async getSearchTypes({ commit }) {
    const searchTypes = await apiClientService.getSearchTypes();
    commit('setSearchTypes', searchTypes);
  },
  setSelected({ commit }, client) {
    commit('setSelectedClient', client);
  },
  async getClientProducts({ commit }, { clientId }) {
    try {
      let products = [];
      const productResponse = await Api.getClientProducts(clientId);
      if (productResponse.status === 200) {
        products = productResponse.data;
      }
      if (products) {
        commit('setClientProducts', { products: products.values, clientId });
      }
    } catch (e) {
      throw e;
    }
  },

  async editClient({ commit }, { field, value }) {
    commit('editClient', { field, value });
  },

  async saveClient({ commit }, { clientId, newClient }) {
    try {
      let client = null;
      const clientResponse = await Api.saveClient(clientId, newClient);
      if (clientResponse.status === 200) {
        client = clientResponse.data;
      }
      if (client) {
        commit('setClient', client);
      }
    } catch (e) {
      throw e;
    }
  },

  async createClient({ commit }, { destinationId, newClient }) {
    let client = null;
    try {
      const clientResponse = await Api.createClient(destinationId, newClient);
      if (clientResponse.status === 200) {
        client = clientResponse.data;
      }
      if (client) {
        commit('setClient', client);
        return client.id;
      }
    } catch (e) {
      throw e;
    }
    return null;
  },

  async assignRoleToClient({ commit }, { clientId, roleId }) {
    try {
      Api.assignRoleToClient(clientId, roleId);
    } catch (e) {
      throw e;
    }
  },
  async getDistinct({ commit }, { destinationId, params }) {
    let distinct = [];
    try {
      const distinctResponse = await Api.getDistinct(destinationId, params);
      if (distinctResponse.status === 200) {
        distinct = distinctResponse.data;
      }
      if (distinct) {
        commit('setDistinctValues', { column: params.distinctColumn, values: distinct });
      }
    } catch (e) {
      throw e;
    }
  },
};
